import Alpine from 'alpinejs';
import { HorizontalScroller } from './horizontal_scroller';

Alpine.data('horizontalScroller', (list_item_data_attr: string, gap_class: string) => new HorizontalScroller(list_item_data_attr, gap_class));
